/**
 * Converts a string to snake_case: lower case, words separated by a single underscore.
 * Handles camelCase/PascalCase word boundaries as well as existing separators such as
 * dots, spaces and hyphens, e.g. `qst.MaritalStatus` -> `qst_marital_status`,
 * `qst.employmentHistory.0.situation` -> `qst_employment_history_0_situation`.
 */
export const toSnakeCase = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .toLowerCase()
    .replace(/^_+|_+$/g, '')
